module.exports = __webpack_public_path__ + "img/Thumbnails_Warehouse.68b30f51.jpg";